import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SettlementTemplate} from "../../../../shared/interface/settlement-template";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {SettlementTemplateService} from "../../../../shared/services/settlement-template.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {error} from "protractor";
import {SendMailDialogComponent} from "../../../../shared/components/send-mail-dialog/send-mail-dialog.component";

@Component({
  selector: 'app-settlements-template-view',
  templateUrl: './settlements-template-view.component.html',
  styleUrls: ['./settlements-template-view.component.scss']
})
export class SettlementsTemplateViewComponent implements OnInit {
  @Input() settlementTemplate: SettlementTemplate;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() deleted = new EventEmitter<any>();
  @Output() initialFiltersSettlementTemplate = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;

  tempDefault = '## Dowolna treść ##';
  tempAmount = '{{KWOTA}}';
  tempMC = '{{MIESIAC-ROZLICZENIOWY}}';
  tempCommissionLess = '{{ROZLICZENIE-0}}';
  tempCommissionZero = '{{ROZLICZENIE=0}}';
  tempCommissionHigher = '{{ROZLICZENIE+0}}';
  tempInitialBalance = '{{SALDO}}';

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private settlementTemplateService: SettlementTemplateService,
    private snack: MatSnackBar,
    private router: Router,

  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć szablon email?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.settlementTemplateService.delete(this.settlementTemplate.uuid)
          .subscribe({
            next: () => {
              this.deleted.emit(false);
              this.snack.open('Pomyślnie usunięto szablon email', '', {duration: 2000});
            },
              error: (response: HttpErrorResponse) => {
                this.deleted.emit(true);
                this.snack.open(response.error.error.text, response.status.toString(), {duration: 5000});
            }
          });
      }
    });
  }
  sendMail(): void{
    this.dialog.open(SendMailDialogComponent, {
      width: '700px',
      data: {
        text: 'Czy na pewno chcesz wysłać szablon email?',
        settlementTemplate: this.settlementTemplate
      },
    });

  }

  copyMessage(val: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka', '', {duration: 2000});

  }


}
